import { AxiosError } from 'axios';
import { PUT_GROUP_EXAM_REGISTRATION_STOP_FILE_PROCESSING } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PutStopFileProcessingRequest {
  applicationUuid: string;
  fileUuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePutStopFileProcessing = ({ onSuccess, onError, onSettled }: Input) => {
  const putStopFileProcessing = async (payload: PutStopFileProcessingRequest) => {
    await axiosClient.put<undefined>(
      PUT_GROUP_EXAM_REGISTRATION_STOP_FILE_PROCESSING(payload.applicationUuid),
      {
        uuid: payload.fileUuid,
      }
    );
  };

  return useCustomMutation(putStopFileProcessing, {
    onSuccess,
    onError,
    onSettled,
  });
};
